/**
 * RoomList Component - Displays and manages all bingo rooms
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import { ROUTES, SUCCESS_MESSAGES } from '../../utils/constants';
import './Rooms.css';

const RoomList = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRooms();
  }, []);

  const loadRooms = async () => {
    try {
      setLoading(true);
      const data = await api.getRooms();
      // La API devuelve {rooms: [...], pagination: {...}}
      setRooms(data.rooms || data || []);
    } catch (error) {
      console.error('Error loading rooms:', error);
      toast.error('Error al cargar salas');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta sala?')) return;
    try {
      await api.deleteRoom(id);
      toast.success(SUCCESS_MESSAGES.ROOM_DELETED || 'Sala eliminada');
      loadRooms();
    } catch (error) {
      toast.error('Error al eliminar sala');
    }
  };

  const columns = [
    { 
      key: '_id', 
      label: 'ID', 
      width: '100px',
      render: (val) => val?.substring(0, 8) + '...'
    },
    { key: 'name', label: 'Nombre' },
    { key: 'roomType', label: 'Tipo' },
    { key: 'maxPlayers', label: 'Max. Jugadores' },
    { 
      key: 'players', 
      label: 'Jugadores',
      render: (val) => val?.length || 0
    },
    { key: 'entryFee', label: 'Entrada' },
    { key: 'prizePool', label: 'Premio' },
    { 
      key: 'isActive', 
      label: 'Estado', 
      render: (val) => (
        <span className={`status-badge status-${val ? 'active' : 'inactive'}`}>
          {val ? 'Activa' : 'Inactiva'}
        </span>
      )
    },
    {
      key: 'actions',
      label: 'Acciones',
      sortable: false,
      render: (_, row) => (
        <div className="action-buttons">
          <Button size="small" onClick={(e) => { e.stopPropagation(); navigate(`${ROUTES.ROOMS}/${row._id}`); }}>
            Ver
          </Button>
          <Button size="small" variant="secondary" onClick={(e) => { e.stopPropagation(); navigate(`${ROUTES.ROOMS}/${row._id}/edit`); }}>
            Editar
          </Button>
          <Button size="small" variant="danger" onClick={(e) => { e.stopPropagation(); handleDelete(row._id); }}>
            Eliminar
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="room-list">
      <Card
        title="Salas de Bingo"
        subtitle={`${rooms.length} salas totales`}
        actions={<Button onClick={() => navigate(`${ROUTES.ROOMS}/create`)}>+ Nueva Sala</Button>}
      >
        <Table 
          columns={columns} 
          data={rooms} 
          loading={loading} 
          onRowClick={(row) => navigate(`${ROUTES.ROOMS}/${row._id}`)} 
          emptyMessage="No hay salas creadas. Crea la primera sala."
        />
      </Card>
    </div>
  );
};

export default RoomList;
